import React from 'react';

import { CRUMBS, TABS } from '../../../../library/fitment/fitment-constants';
import FitmentByVehicle from '../../../../library/fitment/components/fitment-by-vehicle/fitment-by-vehicle';
import FitmentTabs from '../../../../library/fitment/components/fitment-tabs/fitment-tabs';

import './fitment-shell.scss';

export interface FitmentShellProps {
  hideTabs?: boolean;
  isTreadwellStart?: boolean;
  onFocusDropdown?: () => void;
  onFocusLicensePlateDropdown?: () => void;
  onTabSelected?: (tab: string) => void;
  selectedVehicleCrumb?: string;
}

function FitmentShell(props: FitmentShellProps) {
  const {
    hideTabs,
    onFocusDropdown,
    onFocusLicensePlateDropdown,
    onTabSelected,
    selectedVehicleCrumb,
    isTreadwellStart
  } = props;

  const year = String(new Date().getFullYear());

  return (
    <div styleName="fitment">
      <FitmentTabs
        hideTabs={hideTabs}
        onTabSelected={onTabSelected}
        selectedTab={TABS.VEHICLE}
      />
      <div styleName={hideTabs ? 'content-no-tabs' : 'content'}>
        <FitmentByVehicle
          isShowingRecentFitments
          isTreadwellStart={isTreadwellStart}
          onFocusDropdown={onFocusDropdown}
          onFocusLicensePlateDropdown={onFocusLicensePlateDropdown}
          selectedCrumb={selectedVehicleCrumb || CRUMBS.YEAR}
          years={[
            {
              description: year,
              id: year
            }
          ]}
        />
      </div>
    </div>
  );
}

export default FitmentShell;
